export function resizeBoard() {
  const board = document.querySelector('.board-wrapper')
  const wrapper = document.querySelector('.wrapper')
  const container = document.querySelector('.container')
  const boardContainer = document.querySelector('.board-container')
  const playArea = document.querySelector('.play-area')
  const sideAreaContent = document.querySelector('.side-area-content')

  // const maxWidth = parseInt(getComputedStyle(container).maxWidth);

  function layoutVertical() {
    container.classList.add('vertical')

    const delta = wrapper.offsetWidth - boardContainer.offsetWidth

    let size = board.offsetWidth + delta

    if (playArea.offsetHeight + delta <= wrapper.offsetHeight) {
      playArea.style.width =
        board.style.width =
        board.style.height =
        size + 'px'
    } else {
      playArea.style.width =
        board.style.width =
        board.style.height =
        wrapper.offsetWidth - delta + 'px'
    }

    sideAreaContent.style.marginTop = ''
    sideAreaContent.style.height = ''
  }

  function layoutHorizontal() {
    container.classList.remove('vertical')

    boardContainer.style.width = boardContainer.offsetWidth + 'px'
    board.style.position = 'absolute'

    if (board.offsetHeight < boardContainer.offsetHeight) {
      let size = boardContainer.offsetHeight

      playArea.style.width =
        board.style.width =
        board.style.height =
        size + 'px'
    } else if (board.offsetHeight > boardContainer.offsetHeight) {
      let size = boardContainer.offsetHeight

      playArea.style.width =
        board.style.width =
        board.style.height =
        size + 'px'
    }

    boardContainer.style.width = ''
    board.style.position = ''

    sideAreaContent.style.marginTop = boardContainer.offsetTop + 'px'
    sideAreaContent.style.height = board.style.height

    if (container.offsetWidth > wrapper.offsetWidth) {
      layoutVertical()
    }
  }

  let forceVerticalScreenWidth = null
  let isInit = true

  // function resize() {
  if (isInit) {
    layoutHorizontal()
    isInit = false
  }
  if (
    forceVerticalScreenWidth !== null &&
    window.innerWidth <= forceVerticalScreenWidth
  ) {
    layoutVertical()
  } else if (wrapper.offsetWidth < wrapper.offsetHeight) {
    layoutVertical()
  } else if (wrapper.offsetWidth > wrapper.offsetHeight) {
    if (container.offsetWidth > wrapper.offsetWidth) {
      forceVerticalScreenWidth = window.innerWidth
      layoutVertical()
    } else {
      layoutHorizontal()
    }
  }
  // }

  wrapper.style.visibility = 'visible'

}
